import React, { FC } from "react";
import styled from "styled-components";
import Image from "components/atoms/Image";
import { colorImportant } from "lib/constants";

interface Props {
  errorMessage: string;
}

const FormErrorMessage: FC<Props> = ({ errorMessage }) => (
  <>
    {errorMessage.length > 0 && (
      <ErrorInfo>
        <ErrorIcon>
          <Image
            src="/img/icon-attention.svg"
            width="20"
            height="20"
            alt="icon attention"
            display="inline"
            disableHover={true}
          />
        </ErrorIcon>
        <span>{errorMessage}</span>
      </ErrorInfo>
    )}
  </>
);

const ErrorInfo = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
  color: ${colorImportant[500]};
  margin-top: 8px;
`;
const ErrorIcon = styled.span`
  margin-right: 8px;
  display: inline;
  vertical-align: middle;
`;

export default FormErrorMessage;
